<template>
<div class="ac-btn">
	<slot name="label">
		<span>{{label}}</span>
	</slot>
	<span class="caret-wrapper">
		<i class="sort-caret ascending" :class="{active: status === 'ascending' }" @click="changeStatus('ascending')"></i>
		<i class="sort-caret descending" :class="{active: status === 'descending'}" @click="changeStatus('descending')"></i>
	</span>
</div>
</template>
<script>
export default {
	name: "sort",
	props:['label','name','initStatus'],
	emits:['on-change'],
	data() {
		return {
			status:this.initStatus,
		};
	},
	methods: {
		changeStatus(status){
			if(this.status === status){
				this.status = null
			}else{
				this.status = status
			}
			this.$emit('onChange',this.status,this.name)
		},
	},
};
</script>
<style lang="scss" scoped>
.ac-btn {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-size: 1rem;
  line-height: 1.5rem;
}
.ac-btn + .ac-btn {
  margin-left: 0.75rem;
}
.ac-btn .caret-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  height: 34px;
  width: 24px;
  vertical-align: middle;
  cursor: pointer;
  overflow: initial;
  position: relative;
}
.ac-btn .caret-wrapper .sort-caret {
  width: 0;
  height: 0;
  border: 5px solid transparent;
  position: absolute;
  left: 7px;
}
.ac-btn .caret-wrapper .sort-caret.ascending {
  border-bottom-color: #c0c4cc;
  top: 5px;
}
.ac-btn .caret-wrapper .sort-caret.descending {
  border-top-color: #c0c4cc;
  bottom: 7px;
}
.ac-btn .caret-wrapper .sort-caret.ascending.active {
  border-bottom-color: $theme-color;
}
.ac-btn .caret-wrapper .sort-caret.descending.active {
  border-top-color: $theme-color;
}
</style>
  